import React from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { NAV_ITEMS } from '../data/content';
import { CTAButton } from './CTAButton';
import { Logo } from './Logo';
export function Header() {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50 px-3 pt-3 sm:px-5 sm:pt-4" data-id="element-93" data-mp="2wj5po8ja0b7p">
      <div className={`mx-auto max-w-[1240px] border border-white/60 bg-white/95 shadow-[0_18px_40px_-24px_rgba(6,13,61,0.55)] backdrop-blur-xl transition-[border-radius] duration-200 ease-expo ${open ? 'rounded-3xl' : 'rounded-full'}`} data-id="element-94" data-mp="31cgzmijdx83u">
        <div className="flex h-14 items-center justify-between pl-4 pr-2 sm:h-16 sm:pl-6 sm:pr-3" data-id="element-95" data-mp="3fayl09lti8il">
          <a href="#top" aria-label="Elyon Markets — inicio" onClick={() => setOpen(false)} data-id="element-96" data-mp="2wl4csinw1sci">
            <Logo tone="dark" data-id="element-97" data-mp="2rli1iermem6c" />
          </a>

          <nav aria-label="Principal" className="hidden lg:block" data-id="element-98" data-mp="2rnuhwnhqcoha">
            <ul className="flex items-center gap-8" data-id="element-99" data-mp="2mnq26zonbxs4">
              {NAV_ITEMS.map(item => <li key={item.href} data-id="element-100" data-mp="2hon4y1ewqvup">
                  <a href={item.href} className="text-[14.5px] font-medium text-ink-700 transition-colors duration-200 ease-expo hover:text-brand-600" data-id="element-101" data-mp="2hpojifv4u0h6">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-2" data-id="element-102" data-mp="30mzg1spdqfsx">
            <CTAButton label="Abrir cuenta" location="header" size="sm" className="hidden sm:inline-flex" data-id="element-103" data-mp="30m666iv4ja6k" />
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-full text-ink-900 transition-colors duration-200 ease-expo hover:bg-brand-50 lg:hidden" data-id="element-104" data-mp="3tabrb6q3b16x">
              {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-105" data-mp="1mkrvhj8e5rio" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-106" data-mp="18ls8sh4fvmp5" />}
            </button>
          </div>
        </div>

        <AnimatePresence initial={false} data-id="element-107" data-mp="yovyc5uzcqhy">
          {open && <motion.nav id="mobile-nav" aria-label="Menú móvil" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden lg:hidden" data-id="element-108" data-mp="yqgw04clcpk1">
              <ul className="border-t border-line px-3 pb-3 pt-2" data-id="element-109" data-mp="mfg1wh7m1fcr">
                {NAV_ITEMS.map(item => <li key={item.href} data-id="element-110" data-mp="hh4tmawyrcwn">
                    <a href={item.href} onClick={() => setOpen(false)} className="flex h-12 items-center rounded-xl px-3 text-[16px] font-medium text-ink-700 transition-colors duration-200 ease-expo hover:bg-brand-50 hover:text-brand-600" data-id="element-111" data-mp="w4hjucxpu6td">
                      {item.label}
                    </a>
                  </li>)}
                <li className="pt-2" data-id="element-112" data-mp="1f3lprctynkgt">
                  <CTAButton label="Abrir cuenta" location="header_mobile" size="md" className="w-full" data-id="element-113" data-mp="1f2kasx9tqdtt" />
                </li>
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}